module.exports = __webpack_public_path__ + "img/jitiBg.e66ef16f.png";